import { Center, Col, Row, SkeletonCircle, SkeletonText } from "@reverb-ui/react";

export type TListTagRowSkeletonProps = {
    numberOfTags: number;
  };

const isLoaded : boolean = false;

export const TagRowSkeleton = () => {
  return (
    <Row alignItems="center">
      <Col col={7}>
        <Center w="40px" h="40px" marginRight="1rem">
          <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"2.5rem"} skeletonHeight={"2.5rem"} />
        </Center>
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"100%"} skeletonHeight={"2.5rem"} />
      </Col>
      <Col col={2} justifyContent="center">
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"20%"} />
      </Col>
      <Col col={2} justifyContent="center">
        <SkeletonText isLoaded={isLoaded} variant="rect" noOfLines={1} width={"20%"} />
      </Col>
      <Col col={1} justifyContent="center">
        <SkeletonCircle isLoaded={isLoaded} variant="rect" width={6} height={6} />
      </Col>
    </Row>
  );
};

export const ListTagRowSkeleton = ({
    numberOfTags = 1,
} : TListTagRowSkeletonProps) => {
  return (
    <>
      {Array(numberOfTags).fill(0).map((item, index) => (
        <TagRowSkeleton key={index} />
      ))}
    </>
  );
};